import cloneDeep from 'lodash/cloneDeep';
import { call, select } from 'redux-saga/effects';

import { getPaymentOptions, getFinanceOptions } from '../selectors';
import updatePaymentOptions from './api/updatePaymentOptions';

/**
 * @param {Object} payload - Data from action
 */
function* selectPlan(payload) {
    const paymentOptions = yield select(getPaymentOptions);
    const financeOptions = yield select(getFinanceOptions);
    const { index } = payload;

    // Deep copy
    const transformedFinanceOptions = cloneDeep(financeOptions);

    // Update isSelected values
    transformedFinanceOptions.forEach((fo, i) => {
        fo.isSelected = i === index;
    });

    // Take params from the selected financeOptions, to put them at the root
    const {
        financePlan,
        kmPerYearPlan,
        paymentFrequency,
        purchaseMethod,
        selectedTerm,
        selectedCashDown
    } = transformedFinanceOptions[index];

    yield call(updatePaymentOptions, {
        ...paymentOptions,
        cashDown: selectedCashDown,
        financeOptions: transformedFinanceOptions,
        financePlan,
        kmPerYearPlan,
        paymentFrequency,
        purchaseMethod,
        term: selectedTerm
    });
}

export default selectPlan;
